import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const STORAGE_KEY = "hg_consent";
const CONSENT_KEYS = ["ad_storage", "ad_user_data", "ad_personalization", "analytics_storage"];

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

function grantedMap(accept) {
  const val = accept ? "granted" : "denied";
  return CONSENT_KEYS.reduce((m, k) => ({ ...m, [k]: val }), {});
}

function readStored() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function saveStored(state) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ state, ts: new Date().toISOString() }));
  } catch { /* noop */ }
}

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  // On mount: apply persisted choice (if any) or show banner.
  useEffect(() => {
    const stored = readStored();
    if (stored && (stored.state === "accepted" || stored.state === "necessary")) {
      gtag("consent", "update", grantedMap(stored.state === "accepted"));
    } else {
      setVisible(true);
    }
    // Global handler so Footer/Cookiepolitik can reopen the banner
    window.hgOpenConsent = () => setVisible(true);
    return () => { delete window.hgOpenConsent; };
  }, []);

  const decide = (accept) => {
    gtag("consent", "update", grantedMap(accept));
    saveStored(accept ? "accepted" : "necessary");
    setVisible(false);
    if (accept && window.dataLayer) {
      window.dataLayer.push({ event: "consent_accepted" });
    }
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-samtykke"
      data-testid="cookie-banner"
      className="fixed inset-x-0 bottom-0 z-[60] bg-foreground text-background border-t border-background/10 shadow-2xl"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 py-5 md:py-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-8">
        <div className="flex-1 text-sm md:text-[15px] font-light leading-relaxed text-background/85">
          <p>
            Vi bruger cookies og lignende teknologier til at drive hjemmesiden og — med dit samtykke — til statistik via Google Analytics.
            Læs mere i vores{" "}
            <Link to="/cookiepolitik" className="underline underline-offset-2 hover:text-background">cookiepolitik</Link>.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0">
          <button
            type="button"
            data-testid="cookie-necessary"
            onClick={() => decide(false)}
            className="border border-background/40 text-background px-6 py-3 text-xs uppercase tracking-[0.15em] font-semibold hover:bg-background hover:text-foreground transition-colors"
          >
            Kun nødvendige
          </button>
          <button
            type="button"
            data-testid="cookie-accept"
            onClick={() => decide(true)}
            className="bg-background text-foreground px-6 py-3 text-xs uppercase tracking-[0.15em] font-semibold hover:bg-accent hover:text-accent-foreground transition-colors"
          >
            Acceptér alle
          </button>
        </div>
      </div>
    </div>
  );
}
